export default __webpack_public_path__ + "static/media/logo.ad87cbc7.png";